import styled from "styled-components"
import Text from "./Text"

interface ButtonInterface {
    text: string,
    loading?: boolean,
    loadingText?: string,
    onPress: () => void,
    color?: null | "green" | "red" | "gray" | "orange" | "dark",
    bordered?: boolean,
    style?: {},
    icon?: string,
    children?: any,
    disabled?: boolean
}



const returnBackgroundColor = (color) => {
    if (color == "green") {
        return "#067753"
    }
    if(color == "gray"){
        return "#f8f9fa"
    }
    if (color == "red") {
        return "#ed1c24"
    }
    if(color = "dark"){
        return "#19171A"
    }
    if (color == "orange"){
        return "#F48422"
    }
    return "#068FFF"
}

const returnTextColor = (color) => {
    if(color == "gray"){
        return "#4a4a4a"
    }
    if(color == "orange" || color =="dark"){
        return "white"
    }
    return "white";
}

const StyledButton = styled.button`
    background: #067753;
    font-family: inherit;
    border: 1px solid #067753;
    width: 100%;
    padding: 12px 14px;
    border-radius: 6px;
    flexDirection: row;
    justifyContent: center;
    alignItems: center;
    cursor: pointer;
`;


const Button = ({ text, loading, loadingText, onPress, style, color, children, bordered, disabled}: ButtonInterface) => {


    const background = {
        backgroundColor: returnBackgroundColor(color)
    }

    const mergedStyle = {...style, ...background}
    return (
     
        <StyledButton style={mergedStyle}>
            {loading ? (
                <div className="loader"></div>
            ): <Text text={text} size="0.65rem" weight="400" style={{color: "white", fontWeight: "600", fontSize: "0.85rem" }} />}
             
        </StyledButton>
    )
}


export default Button

// const styles = StyleSheet.create({
//     buttonWrapper: {
//         backgroundColor: "#067753",
//         width: "100%",
//         padding: Dimensions.get("window").width < 750 ? 14 : 15,
//         borderRadius: 6,
//         flexDirection: "row",
//         justifyContent: "center",
//         alignItems: "center"
//     },
//     buttonText: {
//         color: "white",
//         fontWeight: "600",
//         fontSize: Dimensions.get("window").width < 750 ? 18 : 18
//     },
// })
